// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// e - the blur event
// inputOnBlur - event callback
// precision - scientific notation of precision. eg. 1e4
const roundToFixedOnBlur = (e, inputOnBlur, precision = 1e0) => {
  let v = e.target.value.replace(/,/g, '')
  // escape blur validation of not a float or int
  if (!v.length || isNaN(v)) {
    return inputOnBlur(e)
  }
  v = Math.round(parseFloat(v) * precision) / precision
  return inputOnBlur(v.toString())
}

export default roundToFixedOnBlur
